'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
export const TabEnum = {
  PRODUCTS: 'products',
  BUNDLE: 'bundle',
  CRM: 'crm',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  CMS: 'cms',
  OPERATIONS: 'operations',
  CRM_SUITE: 'suite',
  CREATE_BUNDLE: 'create-a-bundle'
};
const TabsMap = {
  [TabEnum.CRM]: {
    id: TabEnum.CRM,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.crm.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.crm.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.MARKETING]: {
    id: TabEnum.MARKETING,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.marketing.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.marketing.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.SALES]: {
    id: TabEnum.SALES,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.sales.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.sales.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.SERVICE]: {
    id: TabEnum.SERVICE,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.service.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.service.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.OPERATIONS]: {
    id: TabEnum.OPERATIONS,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.operations.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.operations.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.CMS]: {
    id: TabEnum.CMS,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.cmsHub.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.cmsHub.tabTitle',
    mobileCategory: 'pricingPage.pages.products.tabTitle'
  },
  [TabEnum.CRM_SUITE]: {
    id: TabEnum.CRM_SUITE,
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.crmSuite.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.products.tabs.crmSuite.tabTitle',
    mobileCategory: 'pricingPage.productCategories.bundles'
  },
  [TabEnum.CREATE_BUNDLE]: {
    id: TabEnum.CREATE_BUNDLE,
    slug: 'bundle',
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.bundle.tabTitle"
    }),
    mobileKey: 'pricingPage.pages.bundle.tabTitle',
    mobileCategory: 'pricingPage.productCategories.bundles'
  }
};
export const TabConfig = {
  [TabEnum.PRODUCTS]: {
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabTitle"
    }),
    slug: () => '/marketing',
    children: [TabsMap[TabEnum.CRM], TabsMap[TabEnum.MARKETING], TabsMap[TabEnum.SALES], TabsMap[TabEnum.SERVICE], TabsMap[TabEnum.CMS], TabsMap[TabEnum.OPERATIONS]]
  },
  [TabEnum.BUNDLE]: {
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.productCategories.bundles"
    }),
    slug: () => '/suite',
    children: [TabsMap[TabEnum.CRM_SUITE], TabsMap[TabEnum.CREATE_BUNDLE]]
  }
};